import { useQuery } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { CourseActivityByMonth } from '@ts-core/modules/billing/types';
import {
  getCourseActivityByMonthQuery,
  GetCourseActivityByMonthQueryResult,
  GetCourseActivityByMonthQueryVariables,
} from '../graphql/queries/getCourseActivityByMonthQuery';

export type CourseActivityByMonthHookResult = DataFetcherHookResult<CourseActivityByMonth, 'courseActivity'>;

export interface CourseActivityByMonthHookInput {
  courseId: string;
  year: string;
  month: string;
}

export function useCourseActivityByMonth(input: CourseActivityByMonthHookInput): CourseActivityByMonthHookResult {
  const { courseId, year, month } = input;
  const { data, loading, errorMessage } = useQuery<GetCourseActivityByMonthQueryResult, GetCourseActivityByMonthQueryVariables>(
    getCourseActivityByMonthQuery,
    { variables: { courseId, year, month } }
  );

  return { loading, error: errorMessage, courseActivity: data?.courseActivity };
}
